import axios from "axios";

export default {
  namespaced: true,
  state: {
    policies: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    policiesMessage: ''
  },
  mutations: {
    RECEIVED_POLICIES(state, payload) {
      state.policies = payload;
      state.isReceiving = false;
    },
    RECEIVING_POLICIES(state) {
      state.isReceiving = true;
    },
    RECEIVED_POLICY(state, payload) {
      console.log("RECEIVED POLICY", payload);
      state = Object.assign(state, {
        policies: [...state.policies, payload],
        isReceiving: false,
      })
    },
    RECEIVING_POLICY(state) {
      state.isReceiving = true;
    },
    UPDATED_POLICY(state, payload) {
      console.log(state.policies);
      console.log(payload);
      let index = state.policies.findIndex(policy => policy._id === payload._id);
      state = Object.assign(state, {
        policies: state.policies.map((policy, i) => {
          if (i === index) {
            return Object.assign({}, policy, payload);
          }
          return policy;
        }),
        isUpdating: false,
        policiesMessage: 'Policies has been updating!',
      })
    },
    UPDATING_POLICY(state) {
      state.isUpdating = true;
    },
    DELETED_POLICY(state, payload) {
      console.log("DELETE", payload);
      let indexToDelete = state.policies.findIndex(policy => policy._id === payload._id);
      console.log(indexToDelete);
      let policies = [...state.policies];
      policies.splice(indexToDelete, 1);
      state = Object.assign(state, {
        policies: [...policies],
        isDeleting: false,
        idToDelete: null,
        policiesMessage: 'Policy has been Deleted!',
      });
    },
    DELETING_POLICY(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    deletePolicyRequest({dispatch}, payload) {
      dispatch("deletingPolicy", payload);
      var token = localStorage.getItem('token')
      var url = 'https://api.accountxc.com:3100/delete/policy/' + payload._id;
      var header = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      };
      var del = {
        method: "delete",
        url: url,
        headers: header,
      };

      axios(del)
      .then(function (response) {
        console.log(response.data);
        dispatch("deletePolicy", {_id: payload._id});
      })
      .catch(function (error) {
        console.log(error.data);
      });
    },
    async deletePolicyDetailRequest({dispatch}, payload) {
      try{
        dispatch("deletingPolicy", payload);
        let token = localStorage.getItem("token");
        let url ="https://api.accountxc.com:3100/delete/policydetail/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("deletePolicy", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async deletePolicyImageRequest({dispatch}, payload) {
      try{
        dispatch("deletingPolicy", payload);
        let token = localStorage.getItem("token");
        let url ="https://api.accountxc.com:3100/delete/policyimage/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("deletePolicy", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getPoliciesRequest({dispatch}) {
      dispatch("receivingPolicies");
      var token = localStorage.getItem('token');
      var url = 'https://api.accountxc.com:3100/get/policies';
      var headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      return axios({method: "get",url: url,headers: headers})
      .then(res => {
        dispatch("receivePolicies", res.data);
      })
    },
    async insertPolicyDetailRequest({dispatch}, payload) {
      try{
        dispatch("receivingPolicy");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/insert/policydetail/' + payload.policyid;
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertPolicyImageRequest({dispatch}, payload) {
      let url;
      let data;
      console.log(payload)
      try{
        dispatch("receivingPolicy");
        if(payload.imagefile!=null){
          url = 'https://api.accountxc.com:3100/insert/policyimage/withimage/' + payload.policyid;
          data = new FormData();
          data.append('file', payload.imagefile, payload.imagefilename); 
          delete payload['imagefile'];
          for (let x in payload) {
            data.append(x, payload[x]);
          }
        }
        else{
          data = payload;
          url = 'https://api.accountxc.com:3100/insert/policyimage/' + payload.policyid;
        }
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let response = await axios({method: "POST", url: url, headers: headers, data: data});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    updatePolicyRequest({dispatch}, payload) {
      dispatch("updatingPolicy");
      var id = payload._id;
      delete payload['_id'];
      console.log(id, payload);


      var token = localStorage.getItem('token');
      var url = 'https://api.accountxc.com:3100/update/policy/' + id;
      var header = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      };
      var put = {
        method: "put",
        url: url,
        headers: header,
        data: payload,
      };

      axios(put)
      .then(function (res) {
        console.log(res);
        dispatch("updatePolicy", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    async updatePolicyImageRequest({dispatch}, payload) {
      let url;
      let data;
      console.log(payload);
      try{
        dispatch("updatingPolicy");
        if(payload.imagefile!=null){
          url = 'https://api.accountxc.com:3100/update/policyimage/withimage/' + payload.policyimageid;
          data = new FormData();
          data.append('file', payload.imagefile, payload.imagefilename); 
          delete payload['imagefile'];
          for (let x in payload) {
            data.append(x, payload[x]);
          }
        }
        else{
          data = payload;
          url = 'https://api.accountxc.com:3100/update/policyimage/' + payload.policyimageid;
        }
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        console.log(url)
        let response = await axios({method: "PUT", url: url, headers: headers, data: data});
        dispatch("updatePolicy", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async createPolicyRequest({dispatch}, payload) {
      console.log(payload);
      dispatch("receivingPolicies");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/insert/policy';
      let data = payload;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      console.log(url);
      return axios({method: "post",url: url,headers: headers,data: data})
      .then((response)=> {
        console.log(response.data);
        dispatch("receivePolicy", response.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });	
    },
    async updatePolicyDetailRequest({dispatch}, payload) {
      try{
        dispatch("receivingPolicy");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/update/policydetail/' + payload.policydetailid;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        dispatch("receivePolicy", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    receivePolicies({commit}, payload) {
      commit("RECEIVED_POLICIES", payload)
    },
    receivingPolicies({commit}) {
      commit("RECEIVING_POLICIES")
    },
    receivePolicy({commit}, payload) {
      console.log("HERE");
      console.log(payload);
      commit("RECEIVED_POLICY", payload)
    },
    receivingPolicy({commit}) {
      commit("RECEIVING_POLICY")
    },
    updatePolicy({commit}, payload) {
      commit("UPDATED_POLICY", payload)
    },
    updatingPolicy({commit}) {
      commit("UPDATING_POLICY")
    },
    deletePolicy({commit}, payload) {
      console.log(payload);
      commit("DELETED_POLICY", payload)
    },
    deletingPolicy({commit}, payload) {
      commit("DELETING_POLICY", payload)
    }
  },
};
